import { getJson, postJson, putJson, withDone, withOptional } from '@rad/utility/http';
export const getModerationItems = (p) => getJson('/api/moderation', {
    page: p.page,
    pageSize: p.pageSize,
    flagType: p.flagType || undefined,
    contentType: p.contentType || undefined,
    status: p.status || undefined,
    search: p.search || undefined,
    sortField: p.sortField || undefined,
    sortDirection: p.sortDirection || undefined,
});
export const updateStatus = (id, status, flagType, contentId, contentType) => withDone(withOptional(putJson(`/api/moderation/${id}/status`, { status, flag_type: flagType, content_id: contentId, content_type: contentType })))();
export const dismissFlag = (id, flagType, contentId, contentType) => withDone(withOptional(postJson(`/api/moderation/${id}/dismiss`, { flag_type: flagType, content_id: contentId, content_type: contentType })))();
export const removeContent = (id, flagType) => withDone(withOptional(postJson(`/api/moderation/${id}/remove?flagType=${encodeURIComponent(flagType)}`, {})))();
export const createFlag = (form) => withDone(postJson('/api/moderation/flags', form))();
export const getRoleKinds = (roleName) => withDone(postJson('/api/kind-access/role', { name: roleName }))();
export const updateRoleKinds = (roleName, kinds) => withDone(putJson('/api/kind-access/role', { role_name: roleName, kinds }))();
export const getMyKinds = () => getJson('/api/discussions/my-kinds');
